// src/context/SocketContext.js
import React, {
	createContext,
	useContext,
	useEffect,
	useState,
	useRef,
} from "react";
import { useProperty } from "../PropertyContext/PropertyContext";
import { useAuth } from "../AuthContext/AuthContext";
import { io } from "socket.io-client";
import { baseUrl } from "../../Environments/environment";

const SocketContext = createContext();

export const useSocket = () => {
	return useContext(SocketContext);
};

export const SocketProvider = ({ children }) => {
	const [isConnected, setIsConnected] = useState(false);
	const { selectedPropertyId } = useProperty();
	const { accessToken } = useAuth();
	const socketRef = useRef(null);

	useEffect(() => {
		if (!socketRef.current) {
			socketRef.current = io(`${baseUrl}?propertyId=${selectedPropertyId || ""}`, {
				auth: {
					token: accessToken ? `Bearer ${accessToken}` : "",
				},
			});

			socketRef.current.on("connect", () => {
				setIsConnected(true);
				console.log("Connected to the socket server");
			});

			socketRef.current.on("disconnect", () => {
				setIsConnected(false);
				console.log("Disconnected from the socket server");
			});
		}

		return () => {
			if (socketRef.current) {
				socketRef.current.off("connect");
				socketRef.current.off("disconnect");
				socketRef.current.disconnect();
				socketRef.current = null;
			}
		};
	}, [selectedPropertyId, accessToken]);

	return (
		<SocketContext.Provider value={{ socket: socketRef.current, isConnected }}>
			{children}
		</SocketContext.Provider>
	);
};
